import defaultStates from '@/constants/lifecycle';
import entityIcons from '@/constants/images';

const auditActions = {
  CLOSE_AUDITS: 'CLOSE_AUDITS',
  FETCH_AUDITS: 'FETCH_AUDITS',
  REFRESH_AUDITS: 'REFRESH_AUDITS',
  SHOW_AUDITS: 'SHOW_AUDITS',
  SHOW_AUDITS_ERROR: 'SHOW_AUDITS_ERROR',
  SWITCH_ENTITY_FILTER: 'SWITCH_ENTITY_FILTER',
  TOGGLE_AUDITS_COLUMN_ORDER_BY: 'TOGGLE_AUDITS_COLUMN_ORDER_BY',
  TOGGLE_AUDITS_SINGLE_SORTING: 'TOGGLE_AUDITS_SINGLE_SORTING',
  UPDATE_AUDITS_FILTER: 'UPDATE_AUDITS_FILTER',
};

export const auditStates = {
  ...defaultStates,
};

export const entityFilters = [
  'cataloguedefinition',
  'cohort',
  'configuration',
  'collection',
  'datamodel',
  'dataset',
  'request',
  'role',
  'search',
  'task',
  'taskdefinition',
  'taskquery',
  'user',
  'usergroup',
  'vocabulary',
  'workflow',
];

export const historyEntities = {
  COHORT: 'cohort',
  COLLECTION: 'collection',
  DATASET: 'dataset',
  REQUEST: 'request',
  ROLE: 'role',
  SEARCH: 'search',
  TASK: 'task',
  USER: 'user',
  USERGROUP: 'usergroup',
};

export const auditIcon = (entity) => entityIcons[entity] || 'history';

export const userTypes = {
  USER: 'user',
  USERGROUP: 'usergroup',
};

export default auditActions;
